/** Stable saved keys; `shipped` (Standard) keeps the original shipped artwork. */
export const CARD_FRONTS = [
  'shipped',
  'daily',
  'marquee',
  'paper-cut',
  'clubhouse',
  'mono',
  'arcade',
] as const;
export type CardFront = (typeof CARD_FRONTS)[number];
export const DEFAULT_CARD_FRONT: CardFront = 'shipped';

/** The fronts every player may use: Standard. Every other front is for members. */
export const FREE_CARD_FRONTS: ReadonlySet<CardFront> = new Set<CardFront>(['shipped']);

export function cardFrontOrDefault(value: unknown): CardFront {
  return CARD_FRONTS.find((front) => front === value) ?? DEFAULT_CARD_FRONT;
}
